// Evoluras Logo Components — uses PNG wordmarks and icon
// Variants: "light" (white text for dark bg), "dark" (purple text for dark bg), "mono" (navy text for light bg)

const EvoluraIcon = ({ size = 32, className = "", variant = "sidebar" }) => (
  <img
    src={variant === "favicon" ? "/evoluras-icon.png" : "/evoluras-icon-sidebar.png"}
    alt="Evoluras"
    style={{ height: size, width: size }}
    className={`object-contain ${className}`}
  />
);

const EvoluraLogo = ({ showText = true, size = 32, textClass = "", variant = "mono", className = "" }) => {
  const srcMap = {
    light: "/evoluras-wordmark-light.png",
    dark: "/evoluras-wordmark-dark.png",
    mono: "/evoluras-wordmark-mono.png",
  };
  const src = srcMap[variant] || srcMap.mono;

  if (!showText) {
    return <EvoluraIcon size={size} className={className} />;
  }

  return (
    <img
      src={src}
      alt="Evoluras"
      style={{ height: size }}
      className={`object-contain ${className}`}
    />
  );
};

export { EvoluraIcon, EvoluraLogo };
